import Translations from "../../utils/Translations";
import Flux         from "../../flux/Flux";

function getTranslationByGender(gender) {
	switch (gender) {
		case Flux.Constants.ActorGender.MALE:
			return Translations.get('VideoGridFilterMaleLabel');

		case Flux.Constants.ActorGender.FEMALE:
			return Translations.get('VideoGridFilterFemaleLabel');
	}
}

function getIconByGender(gender) {
	switch (gender) {
		case Flux.Constants.ActorGender.MALE:
			return '-icon-male-line';

		case Flux.Constants.ActorGender.FEMALE:
			return '-icon-female-line';
	}
}

function formatDuration(seconds) {
	let minutes = Math.floor(seconds / 60);
	let rest    = seconds % 60;

	if (minutes < 10) {
		minutes = '0' + minutes;
	}
	if (rest < 10) {
		rest = '0' + rest;
	}

	return minutes + ':' + rest;
}

export {getTranslationByGender, getIconByGender, formatDuration};